export const tryToGetBooleanFromLocalStorage = (key: string, defaultVal: boolean): boolean => {
  try {
    return JSON.parse(localStorage.getItem(key) || '');
  } catch (error) {
    return defaultVal;
  }
}
